import { useState, useEffect, useCallback } from 'react';
import { fetchAbortados } from '../services/reportesV2.services';

// Hook: Ciclos abortados con detalle
export const useAbortados = ({ idLavanderia, dateRange, enabled = true }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !dateRange) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchAbortados({ idLavanderia, dateRange });
      setData(result);
    } catch (e) {
      setError(e.message || 'Error al cargar abortados');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, dateRange, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
